/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadingstarted2Inputs */

const en_menureadingstarted2 = /** @type {(inputs: Menureadingstarted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading your files…`)
};

const de_menureadingstarted2 = /** @type {(inputs: Menureadingstarted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien werden gelesen …`)
};

/**
* | output |
* | --- |
* | "Reading your files…" |
*
* @param {Menureadingstarted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadingstarted2 = /** @type {((inputs?: Menureadingstarted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadingstarted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadingstarted2(inputs)
	return de_menureadingstarted2(inputs)
});
export { menureadingstarted2 as "menuReadingStarted" }